













































import BaseComponent from '@/components/base-component.vue';
import { listCrmVisitEvolutionVisitorsOptions } from '@/services/crm-visit-evolution';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class CrmVisitEvolutionFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = { months: 6, groupBy: { id: 'M', label: 'Mensal' } };
  visitors = [];

  monthOptions = [
    { id: 3, label: '3 meses' },
    { id: 6, label: '6 meses' },
    { id: 12, label: '12 meses' }
  ];

  groupByOptions = [
    { id: 'M', label: 'Mensal' },
    { id: 'W', label: 'Semanal' }
  ];

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.emitFilter();
  }

  mounted() {
    this.loadCombos();
    this.emitFilter();
  }

  emitFilter() {
    this.$emit('filter', this.filter);
  }

  loadCombos() {
    listCrmVisitEvolutionVisitorsOptions().subscribe((res) => {
      this.visitors = res;
    });
  }
}
